import get from 'lodash/get';
export var iam = function iam() {
  return get(window, 'cb.core.iam');
};
export var apricot = function apricot() {
  return get(window, 'cb.apricot');
};
export var profile = function profile() {
  return get(window, 'myap.profile');
};